class Cut {
  constructor(attributes = {}) {
    this.length = attributes.length;
    this.quantity = attributes.quantity;
    this.key = `cut_${Math.floor(Math.random() * 1000)}`
  }
}

export default Cut;
